import { render } from "./MultilingualInput.vue?vue&type=template&id=27638e7b&scoped=true"
import script from "./MultilingualInput.vue?vue&type=script&lang=js"
export * from "./MultilingualInput.vue?vue&type=script&lang=js"

import "./MultilingualInput.vue?vue&type=style&index=0&id=27638e7b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27638e7b"],['__file',"src/common/components/MultilingualInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27638e7b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27638e7b', __exports__)) {
    api.reload('27638e7b', __exports__)
  }
  
  module.hot.accept("./MultilingualInput.vue?vue&type=template&id=27638e7b&scoped=true", () => {
    api.rerender('27638e7b', render)
  })

}


export default __exports__